/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BatchUpdateGoodsStatusReqVo,
  BatchUpdateOrderStatusReqVo,
  ChineseOrderBatchOutboundReqVo,
  ResponseListOrderStatusGroupVo,
  ResponseString,
} from '../models/index';
import {
    BatchUpdateGoodsStatusReqVoFromJSON,
    BatchUpdateGoodsStatusReqVoToJSON,
    BatchUpdateOrderStatusReqVoFromJSON,
    BatchUpdateOrderStatusReqVoToJSON,
    ChineseOrderBatchOutboundReqVoFromJSON,
    ChineseOrderBatchOutboundReqVoToJSON,
    ResponseListOrderStatusGroupVoFromJSON,
    ResponseListOrderStatusGroupVoToJSON,
    ResponseStringFromJSON,
    ResponseStringToJSON,
} from '../models/index';

export interface OrderStatusBatchOrderStatusPutRequest {
    batchUpdateOrderStatusReqVo?: BatchUpdateOrderStatusReqVo;
}

export interface OrderStatusBatchToStockPutRequest {
    requestBody?: Array<number>;
}

export interface OrderStatusBatchUpdateGoodsStatuPutRequest {
    batchUpdateGoodsStatusReqVo?: BatchUpdateGoodsStatusReqVo;
}

export interface OrderStatusBuyingServiceApplyOrderIdPutRequest {
    orderId: number;
}

export interface OrderStatusBuyingServiceCancelOrderIdPutRequest {
    orderId: number;
}

export interface OrderStatusChineseOrderBatchOutboundPostRequest {
    chineseOrderBatchOutboundReqVo?: ChineseOrderBatchOutboundReqVo;
}

export interface OrderStatusChineseOrderOutboundOrderIdPutRequest {
    orderId: number;
}

export interface OrderStatusConfirmAuditOrderIdPutRequest {
    orderId: number;
}

export interface OrderStatusGoodsStatusGoodsIdPutRequest {
    goodsId: number;
    goodsStatus: number;
}

export interface OrderStatusGroupPostRequest {
    requestBody?: Array<number>;
}

export interface OrderStatusKoreaStockCancelSendOrderIdPutRequest {
    orderId: number;
}

export interface OrderStatusKoreaStockCancelWaitProcessPutRequest {
    requestBody?: Array<number>;
}

export interface OrderStatusOrderStatusOrderIdPutRequest {
    orderId: number;
    orderStatus: number;
}

export interface OrderStatusPurchaseDoneOrderIdPutRequest {
    orderId: number;
}

export interface OrderStatusRocketOrderOutboundOrderIdPutRequest {
    orderId: number;
}

export interface OrderStatusThreePlReturnToStockOrderIdPutRequest {
    orderId: number;
}

export interface OrderStatusToStockOrderIdPutRequest {
    orderId: number;
}

/**
 * 
 */
export class OrderStatusControllerApi extends runtime.BaseAPI {

    /**
     * 订单状态·批量调整订单状态
     * 订单状态·批量调整订单状态
     */
    async orderStatusBatchOrderStatusPutRaw(requestParameters: OrderStatusBatchOrderStatusPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order-status/batchOrderStatus`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BatchUpdateOrderStatusReqVoToJSON(requestParameters['batchUpdateOrderStatusReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 订单状态·批量调整订单状态
     * 订单状态·批量调整订单状态
     */
    async orderStatusBatchOrderStatusPut(requestParameters: OrderStatusBatchOrderStatusPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderStatusBatchOrderStatusPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 订单批量转换到最终状态
     */
    async orderStatusBatchToStockPutRaw(requestParameters: OrderStatusBatchToStockPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order-status/batchToStock`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 订单批量转换到最终状态
     */
    async orderStatusBatchToStockPut(requestParameters: OrderStatusBatchToStockPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderStatusBatchToStockPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 批量修改商品状态
     */
    async orderStatusBatchUpdateGoodsStatuPutRaw(requestParameters: OrderStatusBatchUpdateGoodsStatuPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order-status/batchUpdateGoodsStatu`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BatchUpdateGoodsStatusReqVoToJSON(requestParameters['batchUpdateGoodsStatusReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 批量修改商品状态
     */
    async orderStatusBatchUpdateGoodsStatuPut(requestParameters: OrderStatusBatchUpdateGoodsStatuPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderStatusBatchUpdateGoodsStatuPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 代买服务申请
     */
    async orderStatusBuyingServiceApplyOrderIdPutRaw(requestParameters: OrderStatusBuyingServiceApplyOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderStatusBuyingServiceApplyOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order-status/buyingServiceApply/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 代买服务申请
     */
    async orderStatusBuyingServiceApplyOrderIdPut(requestParameters: OrderStatusBuyingServiceApplyOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderStatusBuyingServiceApplyOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 代买取消完成
     */
    async orderStatusBuyingServiceCancelOrderIdPutRaw(requestParameters: OrderStatusBuyingServiceCancelOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderStatusBuyingServiceCancelOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order-status/buyingServiceCancel/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 代买取消完成
     */
    async orderStatusBuyingServiceCancelOrderIdPut(requestParameters: OrderStatusBuyingServiceCancelOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderStatusBuyingServiceCancelOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 中国订单批量出库
     */
    async orderStatusChineseOrderBatchOutboundPostRaw(requestParameters: OrderStatusChineseOrderBatchOutboundPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order-status/chineseOrderBatchOutbound`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChineseOrderBatchOutboundReqVoToJSON(requestParameters['chineseOrderBatchOutboundReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 中国订单批量出库
     */
    async orderStatusChineseOrderBatchOutboundPost(requestParameters: OrderStatusChineseOrderBatchOutboundPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderStatusChineseOrderBatchOutboundPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 订单状态·特殊出库
     * 订单状态·特殊出库
     */
    async orderStatusChineseOrderOutboundOrderIdPutRaw(requestParameters: OrderStatusChineseOrderOutboundOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderStatusChineseOrderOutboundOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order-status/chineseOrderOutbound/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 订单状态·特殊出库
     * 订单状态·特殊出库
     */
    async orderStatusChineseOrderOutboundOrderIdPut(requestParameters: OrderStatusChineseOrderOutboundOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderStatusChineseOrderOutboundOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 确认审核
     */
    async orderStatusConfirmAuditOrderIdPutRaw(requestParameters: OrderStatusConfirmAuditOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderStatusConfirmAuditOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order-status/confirmAudit/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 确认审核
     */
    async orderStatusConfirmAuditOrderIdPut(requestParameters: OrderStatusConfirmAuditOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderStatusConfirmAuditOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 修改商品状态
     */
    async orderStatusGoodsStatusGoodsIdPutRaw(requestParameters: OrderStatusGoodsStatusGoodsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling orderStatusGoodsStatusGoodsIdPut().'
            );
        }

        if (requestParameters['goodsStatus'] == null) {
            throw new runtime.RequiredError(
                'goodsStatus',
                'Required parameter "goodsStatus" was null or undefined when calling orderStatusGoodsStatusGoodsIdPut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['goodsStatus'] != null) {
            queryParameters['goodsStatus'] = requestParameters['goodsStatus'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order-status/goodsStatus/{goodsId}`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 修改商品状态
     */
    async orderStatusGoodsStatusGoodsIdPut(requestParameters: OrderStatusGoodsStatusGoodsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderStatusGoodsStatusGoodsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 根据订单状态组id列表查询订单状态统计信息
     */
    async orderStatusGroupPostRaw(requestParameters: OrderStatusGroupPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListOrderStatusGroupVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order-status/group`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListOrderStatusGroupVoFromJSON(jsonValue));
    }

    /**
     * 
     * 根据订单状态组id列表查询订单状态统计信息
     */
    async orderStatusGroupPost(requestParameters: OrderStatusGroupPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListOrderStatusGroupVo> {
        const response = await this.orderStatusGroupPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 一件代发 出库取消
     */
    async orderStatusKoreaStockCancelSendOrderIdPutRaw(requestParameters: OrderStatusKoreaStockCancelSendOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderStatusKoreaStockCancelSendOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order-status/koreaStockCancelSend/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 一件代发 出库取消
     */
    async orderStatusKoreaStockCancelSendOrderIdPut(requestParameters: OrderStatusKoreaStockCancelSendOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderStatusKoreaStockCancelSendOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 一件代发 出库取消等待处理
     */
    async orderStatusKoreaStockCancelWaitProcessPutRaw(requestParameters: OrderStatusKoreaStockCancelWaitProcessPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order-status/koreaStockCancelWaitProcess`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 一件代发 出库取消等待处理
     */
    async orderStatusKoreaStockCancelWaitProcessPut(requestParameters: OrderStatusKoreaStockCancelWaitProcessPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderStatusKoreaStockCancelWaitProcessPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 订单状态·修改订单状态
     * 订单状态·修改订单状态
     */
    async orderStatusOrderStatusOrderIdPutRaw(requestParameters: OrderStatusOrderStatusOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderStatusOrderStatusOrderIdPut().'
            );
        }

        if (requestParameters['orderStatus'] == null) {
            throw new runtime.RequiredError(
                'orderStatus',
                'Required parameter "orderStatus" was null or undefined when calling orderStatusOrderStatusOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderStatus'] != null) {
            queryParameters['orderStatus'] = requestParameters['orderStatus'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order-status/orderStatus/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 订单状态·修改订单状态
     * 订单状态·修改订单状态
     */
    async orderStatusOrderStatusOrderIdPut(requestParameters: OrderStatusOrderStatusOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderStatusOrderStatusOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 采购完成
     */
    async orderStatusPurchaseDoneOrderIdPutRaw(requestParameters: OrderStatusPurchaseDoneOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderStatusPurchaseDoneOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order-status/purchaseDone/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 采购完成
     */
    async orderStatusPurchaseDoneOrderIdPut(requestParameters: OrderStatusPurchaseDoneOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderStatusPurchaseDoneOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 火箭订单出库
     */
    async orderStatusRocketOrderOutboundOrderIdPutRaw(requestParameters: OrderStatusRocketOrderOutboundOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderStatusRocketOrderOutboundOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order-status/rocketOrderOutbound/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 火箭订单出库
     */
    async orderStatusRocketOrderOutboundOrderIdPut(requestParameters: OrderStatusRocketOrderOutboundOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderStatusRocketOrderOutboundOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 3pl回库
     */
    async orderStatusThreePlReturnToStockOrderIdPutRaw(requestParameters: OrderStatusThreePlReturnToStockOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderStatusThreePlReturnToStockOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order-status/threePlReturnToStock/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 3pl回库
     */
    async orderStatusThreePlReturnToStockOrderIdPut(requestParameters: OrderStatusThreePlReturnToStockOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderStatusThreePlReturnToStockOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 订单转换到最终状态
     */
    async orderStatusToStockOrderIdPutRaw(requestParameters: OrderStatusToStockOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderStatusToStockOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order-status/toStock/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 订单转换到最终状态
     */
    async orderStatusToStockOrderIdPut(requestParameters: OrderStatusToStockOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderStatusToStockOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
